// components/Mission.js
import React from 'react';
import './Mission.css';

const Mission = () => {
  return (
    <section className="mission">
      <div className="container">
        <div className="mission-grid">
          <div className="mission-card">
            <div className="icon">📚</div>
            <h3>Our Mission</h3>
            <p>
              To create sustainable development opportunities for underprivileged 
              communities through education, skill development, and empowerment programs.
            </p>
          </div>
          <div className="mission-card">
            <div className="icon">🎯</div>
            <h3>Our Vision</h3>
            <p>
              A world where every individual has equal opportunities to thrive, 
              regardless of their socio-economic background.
            </p>
          </div>
          <div className="mission-card">
            <div className="icon">💝</div>
            <h3>Our Values</h3>
            <p>
              Compassion, integrity, transparency, and community-driven change 
              guide everything we do.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;